import React from 'react';

const FieldContext = React.createContext(null);

export default FieldContext;
